import NewPasswordForm from '@/routes/reset-password/NewPasswordForm';
import { Navigate, useParams } from 'react-router-dom';

const NewPasswordFormWithGuard = () => {
  const { passwordResetHash } = useParams();

  if (!passwordResetHash) {
    return <Navigate to="/reset-password" replace />;
  }

  return <NewPasswordForm passwordResetHash={passwordResetHash} />;
};

export default NewPasswordFormWithGuard;
